import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import classnames from 'classnames';

import Global404 from './Global404';

import './Global404Certs.css';

function Global404Certs() {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const pathName = location.pathname;
  const isCertificationListPage = Boolean(
    pathName.includes('/certification/list')
  );
  const isCertificationDetailsPage = Boolean(
    pathName.includes('/certification/details')
  );

  const {
    domainInfo: { IDWMS_API_URL, APPLICATION_LOGO },
    leftNavGen2,
    isMenuPinned,
  } = useSelector((state) => state.user || {});

  const goBack = () => {
    setIsLoading(true);

    if (isCertificationListPage) {
      window.location.replace('/ECM/certification/list?status=5');

      return;
    }

    if (isCertificationDetailsPage) {
      window.location.replace('/ECM/campaign/list?status=5');

      return;
    }

    window.location.replace('/ECMv6/request/requestHome');
  };

  const globalCertsClasses = classnames(
    'Global404Certs-pageNotFound',
    leftNavGen2 && 'Global404Certs-pageNotFound--leftNavGen2',
    isMenuPinned && 'Global404Certs-pageNotFound--leftNavGen2Pinned'
  );

  const get404Page = () => {
    if (isCertificationListPage) {
      return (
        <div className='Global404Certs-error-content'>
          <div className='Global404Certs-error-body'>
            Neo Experience for Certifications List page has been disabled
          </div>
          <div className='Global404Certs-error-details'>
            Please contact your administrator to enable Neo Experience for
            Certification List page
          </div>
          <div className='Global404Certs-btn-back-container'>
            <Link
              to='/ECM/campaign/list?status=5'
              className='Global404Certs-btn-back'
              onClick={goBack}>
              Back to Classic List page
            </Link>
          </div>
        </div>
      );
    }

    if (isCertificationDetailsPage) {
      return (
        <div className='Global404Certs-error-content'>
          <div className='Global404Certs-error-body'>
            Neo Experience for Certifications has been disabled
          </div>
          <div className='Global404Certs-error-details'>
            Since this certification was launched with the Neo Experience,
            please contact your administrator to Enable Neo Experience for
            Certifications to work on this certification.
          </div>
          <div className='Global404Certs-btn-back-container'>
            <Link
              to='/ECM/campaign/list?status=5'
              className='Global404Certs-btn-back'
              onClick={goBack}>
              Back to Campaign List
            </Link>
          </div>
        </div>
      );
    }

    return (
      <div className='Global404Certs-error-content'>
        <div className='Global404Certs-error-body'>
          The page you are looking has been removed or temporarily unavailable
        </div>
        <div className='Global404Certs-error-details'>
          Since this certification was launched with the Neo Experience, please
          contact your administrator to Enable Neo Experience for Certifications
          to work on this certification.
        </div>
        <div className='Global404Certs-btn-back-container'>
          <Link
            to='/ECM/campaign/list?status=5'
            className='Global404Certs-btn-back'
            onClick={goBack}>
            Back to Campaign List
          </Link>
        </div>
      </div>
    );
  };

  if (isLoading)
    return (
      <div className={globalCertsClasses}>
        <div className='Global404CertsLoader-wrapper'>
          <div className='Global404CertsLoader' />
        </div>
      </div>
    );

  if (isCertificationListPage || isCertificationDetailsPage) {
    return (
      <div className={globalCertsClasses}>
        <div className='Global404Certs-wrapper'>
          <a href='/request/requestHome'>
            <img
              className='Global404Certs-logo'
              src={`${IDWMS_API_URL}/resource/image/app/${APPLICATION_LOGO}`}
              alt='app-logo'
            />
          </a>
          {get404Page()}
        </div>
      </div>
    );
  }

  return <Global404 />;
}

export default Global404Certs;
